
    import { bootstrapPopover } from '@/directives/bootstrap-popover';
    import { ValidationProvider } from "vee-validate";
    import Vue from 'vue';

    export default Vue.extend({
        name: "SelectInput",
        components: {
            ValidationProvider
        },
        directives: {
            bootstrapPopover
        },
        props: {
            value: {
                type: [String, Number, Array],
                default: ""
            },
            options: {
                type: Array,
                default: () => []
            },
            optionsTextField: {
                type: String,
                required: false
            },
            optionsValueField: {
                type: String,
                required: false
            },
            caption: {
                type: String,
                default: "--Select--"
            },
            rules: {
                type: [String, Object],
                default: ""
            },
            label: {
                type: String,
                default: ""
            },
            helpText: {
                type: String,
                default: ""
            },
            popoverText: {
                type: String,
                default: ""
            },
            disabled: {
                type: Boolean,
                default: false
            },
            formGroupClasses: {
                type: Array,
                default: () => [],
            },
            inputClasses: {
                type: Array,
                default: () => [],
            },
            name: {
                type: String,
                default: ""
            },
            vid: {
                type: String,
                default: undefined
            },
            showRequiredLabel: {
                type: Boolean,
                required: false,
                default: true
            },
            multiple: {
                type: Boolean,
                required: false,
                default: false
            },
            size: {
                type: String,
                required: false,
                default: ""
            },
        },
        data () {
            return {
                currentValue: ""
            }
        },
        watch: {
            value: {
                handler(val) {
                    if(typeof val == "number")
                        this.currentValue = val.toString();
                    else
                        this.currentValue = val;
                },
                //this makes it run the handler function on mount in addition to whenever the value changes
                immediate:true
            },
            currentValue(val) {
                // allows us to use v-model on our input.
                if(typeof this.value == "number") {
                    if(val === '')
                        this.$emit("input", '');
                    else
                        this.$emit("input", Number(val));
                }
                else {
                    this.$emit("input", val);
                }
            }
        },
        methods: {
            getOptionValue(option) {
                if(this.optionsValueField)
                    return option[this.optionsValueField];
                else if(option.value)
                    return option.value
    
                return option;
            },
            getOptionText(option) {
                if(this.optionsTextField)
                    return option[this.optionsTextField];
                else if(option.text)
                    return option.text;
                else
                    return option;
            },
        }
    });
